import { PROJECTS } from "shared/constants/permalinks"
import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useDeleteProject } from "entities/projects/api/useDeleteProject"
import { useNavigateToPermalink } from "features/navigation/model/useNavigateToPermalink"

export function useDeleteProjectOverlayViewModel(projectID: string) {
  const { deleteProject } = useDeleteProject()
  const { closeOverlay } = useCurrentOverlay()
  const { navigate: navigateToProjectsOverview } =
    useNavigateToPermalink(PROJECTS)

  const handleDelete = useEvent(() => {
    deleteProject({ id: projectID })
    closeOverlay()
    navigateToProjectsOverview()
  })

  return {
    onDelete: handleDelete,
    onClose: closeOverlay
  }
}
